<template>
  <div>
    <gSwiper :arr="arr" :maxH="'inherit'"></gSwiper>

    <div class="register">
      <Row :gutter="10" class="top">
        <Col span="16">
        <div class="title">NHNE CHINA 2022 <br>Exhibitor registration</div>
        </Col>
        <Col span="8" class="f-tar">
        <Button shape="circle" style="margin-left:10px" @click="$router.push(`/ex-register/register-mobile`)">中文</Button>
        </Col>
      </Row>
      <registerForm ref="registerForm"></registerForm>
      <registerAddr ref="registerAddr"></registerAddr>

      <div class="f-tac submit-btn">
        <Button type="primary" size="large" @click="handleSubmit" :loading="loading">Submit space application</Button>
      </div>

      <div class="tip-info">
        <p>Remarks：</p>
        <p>Please kindly note that this is an application form not a contract. There is a chance that you may not be allotted the size of stand which you desire.</p>
      </div>
    </div>
  </div>
</template> 

<script> 
import gSwiper from "@components/gSwiper/gSwiper2.vue";
import { mapActions } from "vuex";
import registerForm from "./components/mobile-register-form.vue";
import registerAddr from "./components/mobile-register-addr.vue";
export default {
  name: 'register',
  components: {
    registerForm,
    registerAddr,
    gSwiper,
  },
  props: {},
  data () {
    return {
      loading: false,
      arr: [{ id: 1, path: 'https://api.chinadentalshow.com:8000/upload/images/202208/1e7dbd8bf75247fcba874d82301c8544.png' }],
    
    };
  },
  watch: {},
  computed: {},
  methods: {
    ...mapActions({
      getApplyCompanyRoastCreate: 'registerdModule/getApplyCompanyRoastCreate', // 新增展会接口
    }),
    async handleSubmit () {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let res = await this.$refs.registerForm.handleSubmit();
      this.loading = false;
      if (!res.valid) return;
      let res2 = await this.$refs.registerAddr.validHandle();
      if (!res2.valid) return;
      console.log('registerForm', res);
      console.log('registerAddr', res2);
      let opt = {
        newCompany: { ...res.form },
        lists: [{
          exhibitionId: '57D57E6B-E417-4B44-90F7-A855C96886AD',
          ...res2.ApplyCompanyOrder
        }],
        reportType: 'cn'
      };
      let exname = '';
      res2.exhibition.forEach((c, index) => {
        exname += c.nameEn;
        if (res2.exhibition.length !== index + 1) {
          exname += ','
        }
      });
      console.log('option', opt);
      let bool = await this.getApplyCompanyRoastCreate(opt);
      console.log('getApplyCompanyRoastCreate', bool);
      if (bool && bool.successed) {
        let query = 'company=' + encodeURI(res.form.companyNameEn) + '&exname=' + encodeURI(exname);
        this.$router.push(`/ex-register-en/register-result?${query}`);
      } else {
        let errTxt = bool.msg || bool.info || "error,try again";
        if(bool.errors && bool.errors[0] && bool.errors[0].description) {
          errTxt = bool.errors[0].description;
        }
        this.$Message.error(errTxt);
      }

    },
    IsPC () {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
  created () {
    if (this.IsPC()) {
      this.$router.push(`/ex-register-en/register`);
    }
    document.title = "NHNE booth application";
  },
  mounted () { }
}

</script>

<style lang="scss" scoped>
.register {
  max-width: 1200px;
  margin: 0 auto;
  .top {
    padding: 15px;
  }
  .title {
    font-size: 15px;
    color: #d00300;
    font-weight: bold;
    line-height: 32px;
  }
}
.submit-btn {
  margin-top: 50px;
  text-align: center;
  button {
    padding: 0 46px;
    background-color: #d00300;
    font-size: 16px;
    border-color: #d00300;
    margin-bottom: 30px;
    height: 40px;
    border-radius: 20px;
    font-size: 15px;
    color: #fff;
  }
}
.tip-info {
  margin: 50px auto;
  padding: 15px;
  white-space: nowrap;
  p {
    font-size: 12px;
    color: #666;
    margin-bottom: 4px;
    white-space: normal;
  }
}
</style>
